
import {map, take, distinctUntilChanged, debounceTime} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { GlobalState } from '../global.state';
import { UserService } from './user.service';


@Injectable()
export class RedirectGuardService implements CanActivate {
  constructor(
    private router: Router,
    private _state: GlobalState,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const system = route.data['system'] as string;
    if (window.localStorage['systems']) {
      if (!this.inSystems(system, JSON.parse(window.localStorage['systems']))) {
        this.router.navigate(['/']);
        return false;
      }
      return true;
    } else {
      return this._state.watch('[System] UPDATE').pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        take(1),
        map((systems) => {
          window.localStorage['systems'] = JSON.stringify(systems);
          if (!this.inSystems(system, systems)) {
            this.router.navigate(['/']);
            return false;
          }
          return true;
        }),);
    }
  }

  inSystems(system, systems) {
    return systems.find((elem) => {
      return elem.name === system;
    });
  }
}
